<template>
  <div class="myorder">
    <!-- 面包屑导航-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单中心</el-breadcrumb-item>
      <el-breadcrumb-item>我的订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 内容 -->
    <el-card class="main" style="margin-top: 20px">
      <!-- 头部查询 -->
      <div slot="header" class="clearfix">
        <div style="float:left">
          <el-input placeholder="完整运单号(多条用“,或换行”隔开)" rows="4" 
              type="textarea" style="width:200px"
              prefix-icon="el-icon-info"
              v-model="orderClientNo" clearable
              @keyup.enter.native="query"></el-input>
        </div>
        <div style="margin-top:5px">
          <!-- 订单号查询 -->
          <!-- <el-input v-model="orderVal" placeholder="请输入订单号">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>-->
          <!-- 支付状态查询 -->
          <el-input
            placeholder="请输入品名"
            v-model="goodsName"
            clearable
          ></el-input>
          <el-input
            placeholder="请输入运单号"
            v-model="clientNo"
            style="margin-left: 20px"
            clearable
          ></el-input>
          <el-input
            placeholder="请输入预约号"
            v-model="shipmentId"
            style="margin-left: 20px"
            clearable
          ></el-input>
          <el-select
            size="small"
            clearable
            v-model="paymentStatus"
            placeholder="请选择支付状态"
            style="width: 150px"
          >
            <el-option
              v-for="item in statusData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <!-- 起止时间查询 -->
          <el-date-picker
            v-model="createTime"
            type="datetimerange"
            align="right"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
          <!-- 国家 -->
          <!-- 国家组件 -->
          <country
            :countrys="country"
            @getCty="getCountry"
            style="width: 150px"
          ></country>
        </div>
        <div class="btn">
          <el-button icon="el-icon-search" @click="queryOrder" class="first"
            >查询</el-button
          >
          <el-button type="primary" @click="copyOrder">复制下单</el-button>
          <el-button type="primary" @click="submitDialog">提交付款</el-button>
          <!-- <el-button type="primary" icon="el-icon-download" @click="getMaitou">唛头</el-button> -->
          <el-button
            type="success"
            icon="el-icon-download"
            @click="getMaitou"
            >下载唛头</el-button
          >
          <el-button
            type="success"
            icon="el-icon-download"
            @click="getRucangdan"
            >入仓单</el-button
          >
          <el-button @click="quxiaodingdan">取消订单</el-button>
          <el-badge value="N" class="item">
            <el-button type="info" @click="quxiaodingdan" disabled>数据导出</el-button>
          </el-badge>
          <el-select v-model="fileVal" clearable placeholder="请选择文件类型">
            <el-option
              v-for="item in fileType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-upload
            class="upload-demo"
            :action="UploadUrl()"
            list-type="picture"
            name="upload"
            :on-success="setFile"
            :before-upload="judge"
            :show-file-list="false"
            style="display: inline-block"
          >
            <el-button size="small" type="primary">
              点击上传
              <i class="el-icon-upload el-icon--right"></i>
            </el-button>
          </el-upload>
        </div>
      </div>
      <!-- 状态 -->
      <el-row>
        <el-col :span="2"
          ><div
            class="grid-content bg-purple"
            :class="{ current: num == 1 }"
            v-on:click="change(1)"
          >
            全部【{{ quanbu }}】
          </div></el-col
        >
        <el-col :span="2"
          ><div
            class="grid-content bg-purple"
            :class="{ current: num == 3 }"
            v-on:click="change(3)"
          >
            待入库【{{ dairuku }}】
          </div></el-col
        >
        <el-col :span="2"
          ><div
            class="grid-content bg-purple"
            :class="{ current: num == 4 }"
            v-on:click="change(4)"
          >
            已入仓【{{ yirucang }}】
          </div></el-col
        >
        <el-col :span="2"
          ><div
            class="grid-content bg-purple"
            :class="{ current: num == 5 }"
            v-on:click="change(5)"
          >
            已开船【{{ yikaichuan }}】
          </div></el-col
        >
        <el-col :span="2"
          ><div
            class="grid-content bg-purple"
            :class="{ current: num == 6 }"
            v-on:click="change(6)"
          >
            已到港【{{ yidaogang }}】
          </div></el-col
        >
        <el-col :span="2"
          ><div
            class="grid-content bg-purple"
            :class="{ current: num == 7 }"
            v-on:click="change(7)"
          >
            已提柜【{{ yitigui }}】
          </div></el-col
        >
        <el-col :span="2"
          ><div
            class="grid-content bg-purple"
            :class="{ current: num == 8 }"
            v-on:click="change(8)"
          >
            已派送【{{ yipaisong }}】
          </div></el-col
        >
        <el-col :span="2"
          ><div
            class="grid-content bg-purple"
            :class="{ current: num == 9 }"
            v-on:click="change(9)"
          >
            已取消【{{ yiquxiao }}】
          </div></el-col
        >
      </el-row>
      <!-- 信息列表 -->
      <el-table
        :data="orderData"
        style="width: 100%"
        :stripe="true"
        ref="multipleTable"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        @row-click="handleRowClick"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-link
              v-if="scope.row.unpaid !== 0"
              type="primary"
              :underline="false"
              icon="el-icon-download"
              @click="getBill(scope.row.orderNo)"
              >费用</el-link
            >
            <el-link
              v-if="scope.row.orderLogStatus =='已下单' "
              type="primary"
              :underline="false"
              icon="el-icon-edit"              
              >修改</el-link
            >
          </template>
        </el-table-column>
        <el-table-column label="下单时间" width="88">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | dateformat }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="物流状态"
          prop="orderLogStatus"
          width="100"
        >
          <template slot-scope="scope">
            <el-link
              type="primary"
              :underline="false"
              @click="openDrawer(scope.$index, scope.row)"
            >{{ scope.row.orderLogStatus }}</el-link><br />
            {{ scope.row.orderLogStatusTime | dateformat1 }}
          </template>
        </el-table-column>
        <el-table-column label="运单号" width="120">
          <template slot-scope="scope">
            <el-link
              type="primary"
              :underline="false"
              @click="toOrderdeta(scope.row.orderNo)"
              >{{ scope.row.clientNo }}</el-link
            >
          </template>
        </el-table-column>
        <el-table-column label="订单号/入仓编号" width="120">
          <template slot-scope="scope">
            {{ scope.row.whNo!=null&&scope.row.whNo!=undefined&&scope.row.whNo!=""?scope.row.whNo:scope.row.orderNo }}
          </template>
        </el-table-column>
        <el-table-column
          label="品名"
          prop="goodsName"
          width="120"
        ></el-table-column>
        <el-table-column
          label="目的地"
          prop="shipment"
          width="150"
        ></el-table-column>
        <el-table-column
          label="渠道"
          prop="channelName"
          width="150"
        ></el-table-column>
        <el-table-column label="报关方式" prop="declareTypeTxt">
          <template slot-scope="scope">
            <span
              v-if="scope.row.declareTypeTxt == '退税报关'"
              style="color: #e6a23c"
              >退税</span
            >
            <span v-else>{{ scope.row.declareTypeTxt }}</span>
          </template>
        </el-table-column>
        <el-table-column  label="件 / 重 / 体"  prop="pvw"  width="150">
          <template slot-scope="scope">
              <span v-if="scope.row.realCtn ==0">{{scope.row.ctn}} /{{scope.row.kg}} /{{scope.row.cbm}}</span>
              <span v-else>{{ scope.row.pvw }}</span>
            </template>
        </el-table-column>
        <el-table-column label="计费重" prop="finalsettle" width="150">
            <template slot-scope="scope">
              <span >{{scope.row.finalsettle}}</span>
              <span v-if="scope.row.finalsettle !=0">{{scope.row.settleType=='0'?' KG':' CBM'}}</span>              
            </template>
        </el-table-column>
        <el-table-column label="转单号" prop="enLogno" width="150">
          <template slot-scope="scope">
            <div
            v-for="(item,index) in scope.row.enLogno"
            :key="index">
            <el-link
              tyle="info"
              :underline="false"
              @click="openDrawerTrack(scope.$index, item)"
            >{{item}}</el-link>
            </div>
            <span v-if="scope.row.trackStatus!=''">【{{scope.row.trackStatus}}】</span>
          </template>
        </el-table-column>
        <el-table-column label="付款状态">
          <template slot-scope="scope">
            <span v-if="scope.row.recStatus == '0'" style="color: #f56c">{{
              scope.row.recStatusText
            }}</span>
            <span v-else>{{ scope.row.recStatusText }}</span>
          </template>
        </el-table-column>
        <el-table-column label="应付金额/元" prop="unpaid" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.unpaid != '0'" style="color: #f56c">{{
              scope.row.unpaid
            }}</span>
            <span v-else>{{ scope.row.unpaid }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页功能 -->
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 40, 60, 80, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>

      <el-dialog
        class="addDialog"
        title="新增收款确定"
        :before-close="closeDialog"
        :visible.sync="dialogTableVisible"
        :close-on-click-modal="false"
        width="25%"
        style="text-align:center;">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="折合币种" prop="toCurrency">
              <el-select
                v-model="ruleForm.currency"
                filterable
                clearable
                placeholder="请选择币种"
                size="small"
                style="width:100%;"
              >
                <el-option
                  v-for="(item,index) in options2"
                  :key="index"
                  :label="item.name"
                  :value="item.shortname"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input style="width:100%;margin-left:0" type="textarea" v-model="ruleForm.remark"></el-input>
            </el-form-item>
            <el-form-item label="银行账户" prop="settleAccountId">
              <el-select v-model="ruleForm.settleAccountId" filterable  clearable placeholder="请选择银行账户" size="small" style="width:100%;">
                <el-option
                  v-for="(item,index) in options"
                  :key="index"
                  :label="item.abbr+'\n'+item.account"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="实际打款日" prop="realityPayTime">
              <el-date-picker
                  v-model="ruleForm.realityPayTime"
                  style="width:100%;"
                  type="date"
                  placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="实际金额" prop="money">
              <el-input v-model="ruleForm.money" placeholder="选填" style="width:100%;"></el-input>
            </el-form-item>
            <el-form-item label="水单上传" prop="deliveryImg" >
          <el-upload style="text-align:left"
                class="upload-demo"
                :action="'http://localhost:8087/manager/api/1.0/file/upload'"
                :on-success="businessSuccess"
                :on-remove="businessRemove"
                :before-upload="beforeUpload"
                list-type="picture"
                :limit="1"
                name="upload"
                ref="uploadDeliveryImgRef"
              >
                <el-button size="small" type="primary">
                  上传水单
                </el-button>
          </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitPayment('ruleForm')">提交</el-button>
        </div>
      </el-dialog>
      <el-dialog
        class="abnormal"
        title="唛头下载"
        :visible.sync="dialogFormVisible3"
        :close-on-click-modal="true"
        :modal-append-to-body="false"
        :destroy-on-close="true"
        width="35%"
      >
        <div class="dialog-footer" style="text-align:center;">
          <el-select v-model="marks" clearable placeholder="请选择唛头模板" value-key="id">
            <el-option
              v-for="(item,index) in options3"
              :key="index"
              :label="item.marks"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="success" @click="getMaitou2()">单张唛头</el-button>
          <el-button type="info" @click="getMaitou2('a4')">A4纸唛头</el-button>
          <el-button type="info" @click="getMaitou2('a4s')">A4纸唛头(无代码)</el-button>
        </div>
      </el-dialog>
    </el-card>

    <!-- 物流抽屉 -->
    <el-drawer title="最新物流状态" :visible.sync="drawer" :with-header="false" >
      <div class="drawer-box">
        <p>订单物流进度</p>
        <el-timeline style="overflow-y: auto;height: 600px;float: left;padding:1px;" >
            <el-timeline-item
              v-for="(item, index) in schedule"
              :key="index"
              :icon="item.icon"
              :size="item.size"
              :type="item.type"
              :color="index === 0 ? '#ff0000' : ''"
            >
              <b>{{item.content}}</b>
              <span style="margin-left:15px">{{item.createTime|dateformat}}</span>
            </el-timeline-item>
          </el-timeline>
      </div>
    </el-drawer>

    <el-drawer title="派送信息" :visible.sync="drawerTrack" :with-header="false" >
      <div class="drawer-box">
        <p>订单派送状态</p>
        <el-timeline style="overflow-y: auto;height: 600px;float: left;padding:1px;" >
            <el-timeline-item
              v-for="(item, index) in trackData"
              :key="index"
              :icon="item.icon"
              :size="item.size"
              :type="item.type"
              :color="index === 0 ? '#ff0000' : ''"
            >
              <b>{{item.tracking_detail}}</b>
              <span style="margin-left:15px">{{item.checkpoint_date}}</span>
            </el-timeline-item>
          </el-timeline>
      </div>
    </el-drawer>
  </div>
</template>

<script>
//引入api
import httpApi from "@/http/api";
//引入组件
import Country from "@/components/Country";
export default {
  components: {
    Country,
  },
  data() {
    const checkCurrency = (rule, value, callback) => {
      if (this.ruleForm.currency == "") {
        return callback(new Error('此项不能为空'))
      }else{
        callback();
      }
    };
    return {
      radio: "", //单选按钮
      fileVal: "",
      fileType: [
        { label: "退税报关", value: "1" },
        { label: "FBA标签", value: "2" },
        { label: "报价文件", value: "3" },

        { label: "箱单发票", value: "5" },
        { label: "POA", value: "6" },
        { label: "税号证明", value: "7" },
        { label: "报关单", value: "8" },
        { label: "保险单", value: "9" },
        { label: "认证资料", value: "10" },
        { label: "过磅单", value: "13" },

        { label: "收款水单", value: "18" },
        { label: "产品图", value: "25" },
 
        { label: "保函", value: "27" }
      ],
      dialogTableVisible: false,
      options: [],
      options2: [],
      options3: [],
      settleAccountId: "",
      orderClientNo: "",
      dialogFormVisible3: false,
      templateSelection: "", //订单号
      country: "", //国家
      // orderVal: "", //订单号
      orderData: [], //订单列表
      currentPage: 1, //分页初始页
      pagesize: 20, //分页每页数据
      total: 0, //分页总数
      marks: {},
      statusData: [
        {
          value: 0,
          label: "未支付",
        },
        {
          value: 1,
          label: "已支付",
        },
      ],
      ruleForm: {
        money: "",
        remark: "",
        settleAccountId: "",
        currency: "",
        realityPayTime:null,
        sellerName:"",
        deliveryImg: ""
      },
      rules: {
        money: [{ required: false, message: "此项不能为空", trigger: "blur" }],
        settleAccountId: [{ required: true, message: "此项不能为空", trigger: "change" }],
        toCurrency: [{ required: true, validator: checkCurrency, trigger: "change" }]
      },
      paymentStatus: "", //支付状态
      createTime: [], //下单时间
      orderNo: "",
      orderNoList: [],
      clientNo: "",
      drawerTrack: false,
      trackData: [],
      shipmentId: "",
      goodsName: "",
      mtDownType: true,
      whStatus: "",
      whStatusList: [],
      num: 1,
      quanbu: "0",
      dairuku: "0",
      yirucang: "0",
      yikaichuan: "0",
      yidaogang: "0",
      yitigui: "0",
      yipaisong: "0",
      yiquxiao: "0",
      orderLogStatus: "", //物流状态
      orderStatusList: "0,1,2",
      drawer: false,
      schedule: [],
    };
  },
  methods: {
    UploadUrl(){
      return this.mApi + "/file/upload"
    },
    //打开物流抽屉
    openDrawerTrack(index, row){
      let that = this;
      that.trackData = [];
      httpApi
        .getTracking({
          params:{
            numbers: row
          }
        })
        .then(res=>{
          if(res.data.code=="ok"){
            that.trackData = res.data.data;
            this.drawerTrack = true;
          }else{
            that.$message.error(res.data.message);
          }
        })
    },
    setFile(response) {
      let that = this;
      let arr = response.data;
      httpApi
        .addFile({
          ext: arr.ext,
          name: arr.filename,
          orderNo: that.orderNoList[0],
          size: arr.size,
          type: that.fileVal,
          url: arr.url
        })
        .then(res => {
          if (res.data.code == "ok") {
            that.$message.success("上传成功");
            that.init();
            that.fileVal = "";
          } else {
            that.$message.error(res.data.message);
          }
        });
    },
    judge(file) {
      if (this.orderNoList.length === 1) {
        if (this.fileVal == "") {
          this.$message.warning("请选择文件类型");
          return false;
        }
      }else{
        this.$message.warning("请选择一条订单!")
        return false;
      }
    },
    change: function (index) {
      let that = this;
      this.currentPage = 1;
      this.num = index;
      if (this.num === 1) {
        that.orderLogStatus = "";
        that.orderStatusList = "0,1,2";
        that.orderLists();
      } else if (this.num === 3) {
        that.orderLogStatus = "1,2";
        that.orderStatusList = "0,1,2";
        that.orderLists();
      } else if (this.num === 4) {
        that.orderLogStatus = "3,4,5,6";
        that.orderStatusList = "0,1,2";
        that.orderLists();
      } else if (this.num === 5) {
        that.orderLogStatus = "7,15";
        that.orderStatusList = "0,1,2";
        that.orderLists();
      } else if (this.num === 6) {
        that.orderLogStatus = "8,9,10,11";
        that.orderStatusList = "0,1,2";
        that.orderLists();
      } else if (this.num === 7) {
        that.orderLogStatus = "12,16";
        that.orderStatusList = "0,1,2";
        that.orderLists();
      } else if (this.num === 8) {
        that.orderLogStatus = "13,14";
        that.orderStatusList = "0,1,2";
        that.orderLists();
      } else if (this.num === 9) {
        that.orderLogStatus = "";
        that.orderStatusList = "3";
        that.orderLists();
      }
    },
    //点击订单号跳往详情
    toOrderdeta(orderNo) {
      this.$router.push("/orderdetails/" + orderNo);
    },
    //点击当前行选中radio
    // rowClick(column) {
    //   this.orderNo = column.orderNo;
    //   this.whStatus = column.whStatus;
    //   this.radio = this.orderData.findIndex((item) => {
    //     //拿到当前行在数组的下标
    //     return item.orderNo == column.orderNo;
    //   });
    //   this.templateSelection = column.orderNo;
    // },
    //点击行选中
    handleRowClick(row, column, event){
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    //选择
    handleSelectionChange(val) {
      this.orderNoList = val.map(i => i.orderNo);
      this.whStatusList = val.map(i => i.whStatus);
    },
    init(){
      let that=this
      httpApi
      .listParams({params:{
        type:"sys_bank_type",
        enable:"1"
      }})
      .then(res => {
        if (res.data.code == "ok") {
          that.options = res.data.data;
        }
      });
    },
    init2() {
      let that = this;
      httpApi
        .listParams( {
          params: {
            type: "sys_currency",
            enable:"1"
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            that.options2 = res.data.data;
          }
        });
    },
    init3() {
      let that = this;
      httpApi
        .listParams( {
          params: {
            type: "sys_marks",
            enable:"1"
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            that.options3 = res.data.data;
          }
        });
    },
    //移除签收证明图片
    businessRemove() {
      this.ruleForm.deliveryImg = ""
      this.$refs.uploadDeliveryImgRef.clearFiles(); //清空上传单列表
    },
    businessSuccess(file, fileList){
      let data = fileList.response.data;
      this.ruleForm.deliveryImg = data.url;
    },
    beforeUpload(file){//
        let isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/bmp';
        let isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
            this.$message.error('只能上传jpeg、jpg、png、bmp格式的图片');
        }
        if (!isLt2M) {
            this.$message.error('上传图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
    },
    //复制下单
    copyOrder() {
      if(this.orderNoList.length == 1){
        this.orderNo = this.orderNoList[0];
        if (this.orderNo) {
          this.$router.push({
            path: "/orderby2",
            query: { orderNo: this.orderNo },
          });
        } else {
          this.$message.warning("请选择订单");
        }
      }else{
        this.$message.warning("请选择一条订单！")
      }
    },
    //取消订单
    quxiaodingdan() {
      let that = this;
      if(that.orderNoList.length === 1){
        that.orderNo = that.orderNoList[0];
        if (that.orderNo) {
          httpApi
            .cancel({
              orderNo: that.orderNo,
            })
            .then((res) => {
              if (res.data.code == "ok") {
                that.$message.success("订单取消成功");
                that.orderLists();
                that.orderListsCount();
              } else {
                that.$message.error(res.data.message);
              }
            });
        } else {
          that.$message.warning("请选择订单");
        }
      }else{
        this.$message.warning("请选择一条订单！")
      }
    },
    //下载唛头
    getMaitou() {
      if(this.orderNoList.length === 1){
        this.templateSelection = this.orderNoList[0];
        if (this.templateSelection) {
          this.dialogFormVisible3 = true;
          this.init3();
        } else {
          this.$message.error("请选择订单");
        }
      }else{
        this.$message.warning("请选择一条订单！")
      }
    },
    //下载唛头
    getMaitou2(type) {
      this.dialogFormVisible3 = false;
      let typeFlag = type ? type : "";
      window.open(
        this.mApi +
              "report/mai_tou3?orderNo=" + this.templateSelection + "&type=" + typeFlag + "&marksModel=" + this.marks.marksModel +"&suffix="+this.marks.suffix+"&serialNum="+this.marks.serialNum+"&isHasSuffix="+this.marks.isHasSuffix
      );
    },
    //下载入仓单
    getRucangdan() {
      if(this.orderNoList.length === 1){
        this.templateSelection = this.orderNoList[0];
        if (this.templateSelection) {
          window.open(
            this.mApi + "report/ru_cang_dan?orderNo=" + this.templateSelection
          );
        } else {
          this.$message.error("请选择订单");
        }
      }else{
        this.$message.warning("请选择一条订单！")
      }
    },
    getBill(e) {
      window.open(this.mApi + "report/bill?orderNos=" + e);
    },
    //查询
    queryOrder() {
      this.orderLists();
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.currentPage = 1;
      //每页下拉显示数据
      this.orderLists();
    },
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      //点击第几页
      this.orderLists();
    },
    // 国家选择
    getCountry(e) {
      this.country = e;
    },
    //查询订单分页
    orderLists() {
      let that = this;
      let getTime = "";
      let setTime = "";
      that.radio = ""; //清空单选框
      that.orderNo = ""; //清空单选框订单号
      if (that.createTime.length !== 0) {
        //转化为时间戳
        getTime = new Date(that.createTime[0]).getTime() / 1000;
        setTime = new Date(that.createTime[1]).getTime() / 1000;
      }
      httpApi
        .orderList({
          params: {
            page: that.currentPage,
            rows: that.pagesize,
            createStartTime: getTime, //下单起止时间
            createEndTime: setTime, //下单截至时间
            clientNos: that.orderClientNo,
            country: that.country, //国家
            recStatus: that.paymentStatus, //状态码
            clientNo: that.clientNo, //运单号
            shipmentId: that.shipmentId, //亚马逊预约号
            goodsName: that.goodsName,
            unpaid: that.unpaid,
            orderLogStatusList: that.orderLogStatus, //订单物流状态
            orderStatusList: that.orderStatusList, //订单状态
          },
        })
        .then((res) => {
          if (res.data.code == "ok") {
            that.orderData = res.data.data.rows;
            that.total = res.data.data.total;
            let arr = []; //拿到件数/重量/体积
            for (let i in that.orderData) {
              if (that.orderData[i].enLogno!=null&&that.orderData[i].enLogno!=undefined){
                that.orderData[i].enLogno=that.orderData[i].enLogno.split("\n");
              }
              if (that.orderData[i].realKg == 0) {
                that.orderData[i].realKg = "_";
              }
              if (that.orderData[i].finalsettle == 0) {
                that.orderData[i].finalsettle = "_";
              }
              //私人地址和fba地址
              if (that.orderData[i].shipmentType == "1") {
                that.orderData[i].shipment =
                  that.orderData[i].shipmentCountry +
                  " / " +
                  that.orderData[i].shipmentZip;
              } else {
                that.orderData[i].shipment =
                  that.orderData[i].shipmentCode +
                  " / " +
                  that.orderData[i].shipmentZip;
              }
              var unit = "";
              if (that.orderData[i].settleType == 0) {
                unit = "kg";
              } else if (that.orderData[i].settleType == 1) {
                unit = "cbm";
              }
              // arr.push(
              //   that.orderData[i].ctn +
              //     "件 / " +
              //     that.orderData[i].realKg +
              //     "kg / " +
              //     that.orderData[i].finalsettle
              // );
              arr.push(
                that.orderData[i].realCtn +
                  " / " +
                  that.orderData[i].realKg +
                  " / " +
                  that.orderData[i].realCbm
              );
              for (let j in arr) {
                that.orderData[j].pvw = arr[j];
              }
            }
            //拿到付款状态
            for (let i in that.orderData) {
              if (that.orderData[i].recStatus == "0") {
                that.orderData[i].recStatusText = "未付款";
              } else if (that.orderData[i].recStatus == "1") {
                that.orderData[i].recStatusText = "已付款";
              }
            }
          } else {
            that.$message.error(res.data.message);
          }
        });
    },
    submitDialog(){
      let that = this;
      if (that.orderNoList.length > 0) {
        that.dialogTableVisible = true;
      } else {
        that.$message.warning("请选择");
      }
    },
    //关闭弹窗
    closeDialog() {
      this.dialogTableVisible = false;
    },
    submitPayment(formName){
      let that = this;
      that.$refs[formName].validate(valid => {
        if (valid) {
          httpApi
            .submitPayment({
              orderNoList: that.orderNoList,
              realMoney: that.ruleForm.money,
              remark: that.ruleForm.remark,
              settleAccountId: that.ruleForm.settleAccountId,
              toCurrency: that.ruleForm.currency,
              realityPayTime:that.ruleForm.realityPayTime / 1000,
              picUrl:that.ruleForm.deliveryImg
            })
            .then(res => {
              if (res.data.code == "ok") {
                this.closeDialog();
                this.$refs.ruleForm.resetFields();
                if(res.data.data !== null){
                  that.$message.warning(res.data.data);
                }else{
                  that.$message.success("保存成功");
                }
              } else {
                that.$message.error(res.data.message);
              }
            });
        } else {
          return false;
        }
      });
    },
    //查询状态数字
    orderListsCount() {
      let that = this;

      const arr = [
        {
          orderLogStatusList: "",
          orderStatusList: "0,1,2",
          s: "quanbu",
        },
        {
          orderLogStatusList: "1,2",
          orderStatusList: "0,1,2",
          s: "dairuku",
        },
        {
          orderLogStatusList: "3,4,5,6",
          orderStatusList: "0,1,2",
          s: "yirucang",
        },
        {
          orderLogStatusList: "7,15",
          orderStatusList: "0,1,2",
          s: "yikaichuan",
        },
        {
          orderLogStatusList: "8,9,10,11",
          orderStatusList: "0,1,2",
          s: "yidaogang",
        },
        {
          orderLogStatusList: "12,16",
          orderStatusList: "0,1,2",
          s: "yitigui",
        },
        {
          orderLogStatusList: "13,14",
          orderStatusList: "0,1,2",
          s: "yipaisong",
        },
        {
          orderLogStatusList: "",
          orderStatusList: "3",
          s: "yiquxiao",
        },
      ];

      for (var i = 0; i < arr.length; i++) {
        var obj = arr[i];
        httpApi
          .orderListCount({
            params: {
              orderLogStatusList: obj.orderLogStatusList, //订单物流状态
              orderStatusList: obj.orderStatusList,
              s: obj.s,
            },
          })
          .then((res) => {
            if (res.data.code == "ok") {
              const s = res.config.params.s;
              if (s === "quanbu") {
                that.quanbu = res.data.data;
              }
              if (s == "dairuku") {
                that.dairuku = res.data.data;
              }
              if (s == "yirucang") {
                that.yirucang = res.data.data;
              }
              if (s == "yikaichuan") {
                that.yikaichuan = res.data.data;
              }
              if (s == "yidaogang") {
                that.yidaogang = res.data.data;
              }
              if (s == "yitigui") {
                that.yitigui = res.data.data;
              }
              if (s == "yipaisong") {
                that.yipaisong = res.data.data;
              }
              if (s == "yiquxiao") {
                that.yiquxiao = res.data.data;
              }
            } else {
              that.$message.error(res.data.message);
            }
          });
      }
    },
    //打开物流抽屉
    openDrawer(index, row){
      let that = this;
      httpApi
        .findOrder( {
          params: { orderNo: row.orderNo }
        })
        .then(res => {
          if (res.data.code == "ok") {
            that.logisticsStatus = res.data.data.findOrderLogisticsResponseList[0];
            that.schedule = res.data.data.findOrderLogisticsResponseList;
            
          } else {
            that.$message.error(res.data.message);
          }
        });
      this.drawer = true;
    },
  },
  created() {
    this.orderLists();
    this.init();
    this.init2();
    this.orderListsCount();
  },
  watch: {
    createTime(newVal, oldVal) {
      if (newVal == null) {
        this.createTime = [];
      }
    },
    immediate: true,
    deep: true,
  },
};
</script>

<style lang="less" scoped>
//tab
.current {
  color: #6397f1;
  background-color: #fff;
  border-right-color: #dcdfe6;
  border-left-color: #dcdfe6;
  // border-top: 1px solid #ccc!important;
}
.el-row {
  background: #ebeef5;
  color: #909399;
  // border-top: 1px solid #ccc;
  // border-bottom: 1px solid #ccc;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
.grid-content {
  font-size: 14px;
  min-height: 40px;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  border: 1px solid transparent;
  margin-top: -1px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.clearfix {
  flex-wrap: wrap;
  .btn {
    margin-top: 10px;
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    .first {
      margin-left: 0;
    }
  }
}
/deep/.el-card__body {
  padding: 0px 20px 20px;
}

/deep/.el-radio__label {
  display: none;
}
/deep/.block {
  margin-top: 20px;
  text-align: center;
}
/deep/ .el-drawer:focus {
  outline: none;
}
.drawer-box{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 30px;
  p:first-child{
    font-size: 20px;
    margin-bottom: 20px;
  }
  p:last-child{
    font-size: 16px;
    color: red;
  }
}
</style>
<style lang="less" scoped>